<template>
  <div id="pieChart"></div>
</template>
<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
// import am4themes_animated from "@amcharts/amcharts4/themes/frozen";
export default {
  props: {
    data: Array,
    label: String,
  },
  mounted() {
    this.createChartPie();
  },
  methods: {
    createChartPie() {
      // am4Donnuts.useTheme(am4themes_animated);

      // Create chart instance
      var chart = am4core.create("pieChart", am4charts.PieChart);

      // Add data
      chart.data = this.data;

      // Add label
      chart.innerRadius = 150;
      if (this.label !== undefined) {
      var label = chart.seriesContainer.createChild(am4core.Label);
        label.text = `${this.label}`;
        label.horizontalCenter = "middle";
        label.verticalCenter = "middle";
        label.fontSize = 23;
      }

      // Add and configure Series
      var pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "size";
      pieSeries.dataFields.category = "sector";
      pieSeries.slices.template.strokeWidth = 10;
      pieSeries.ticks.template.disabled = true;
      pieSeries.labels.template.disabled = true;

      chart.legend = new am4charts.Legend();
      chart.legend.position = "right";
    },
  },
};
</script>
<style lang="scss">
#pieChart {
  height: 100%;
  min-height: 400px;
}
</style>